var _rect, _style, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlso(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 900,
    height: 330,
    viewBox: "0 0 900 330",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "none"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "text{font-family:\"Noto Serif Georgian\",\"Noto Sans Georgian\",Georgia,serif; font-weight:800; fill:#000; letter-spacing:-1px;} .small{font-weight:700;}")), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "",
    x: 450,
    y: 105,
    fontSize: 86,
    textAnchor: "middle",
    transform: "rotate(-3 450 105)"
  }, "\u10D0\u10DB\u10D8\u10E2\u10DD\u10DB \u10D8\u10E1")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "",
    x: 450,
    y: 245,
    fontSize: 86,
    textAnchor: "middle",
    transform: "rotate(1 450 245)"
  }, "\u10E8\u10D4\u10DE\u10E7\u10E0\u10DD\u10D1\u10D8\u10DA\u10D8 \u10D2\u10D0\u10EE\u10D3\u10D0")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlso);
export default __webpack_public_path__ + "static/media/also.48d0500b196a69afa72592413e7f69a7.svg";
export { ForwardRef as ReactComponent };